<template>
  <!-- Importing Login Component -->
  <LoginForm></LoginForm>
</template>
<script>
import LoginForm from "../../components/Auths/Login.vue";
import { mapState } from "vuex";

export default {
  name: "Sign In View",
  components: { LoginForm },
  computed: mapState(["leadData", "att_user"]),
  mounted() {
    if (
      this.att_user?.data?.password != null &&
      this.att_user?.data?.password != ""
    ) {
      this.$toast.error("Already logged In");
      this.$router.push("/home");
    }
  },
};
</script>
